import { render, staticRenderFns } from "./navigation-node.vue?vue&type=template&id=a31b7afa&"
import script from "./navigation-node.vue?vue&type=script&lang=ts&"
export * from "./navigation-node.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports